/**
 * screen-tidy: screen-only line breaking for 「·」-separated lines (vocab-tag
 * lines, meta lines). Each item becomes a nowrap span that ends with its own
 * 「 ·」, so a line only ever breaks after a 「·」: seat codes, cards, bb amounts
 * and term tags never split, and 「·」 never starts a line. textContent is
 * unchanged (same characters, same order); Copy / PNG / payload never use this.
 */
import { el } from './dom'

export const DOT_SEP = ' · '

export function dotSegments(nodes: Array<string | HTMLElement>, sep: string = DOT_SEP): Array<string | HTMLElement> {
  const head = sep.replace(/\s+$/, '') // ' ·'
  const tail = sep.slice(head.length) // ' '
  const out: Array<string | HTMLElement> = []
  let group: Array<string | HTMLElement> = []
  const close = () => {
    if (group.length) out.push(el('span', { className: 'dotSeg' }, group))
    group = []
  }
  for (const n of nodes) {
    if (typeof n !== 'string') { group.push(n); continue }
    const parts = n.split(sep)
    parts.forEach((p, i) => {
      if (i > 0) {
        group.push(head)
        close()
        out.push(tail)
      }
      if (p) group.push(p)
    })
  }
  close()
  return out
}
